import { gql } from '@apollo/client';

import {
  WITH_COUNT_VARIABLES,
  WITH_COUNT_ARGUMENTS
} from '../../../queries/withCount';

const ERRORS = `errors { path, message }`;

const RECURRING_SALE_FIELDS = `
  id
  name
  recurrence
  frequency
  dayOfWeek
  weekOfMonth
  startOn
  preBidOpenAt
  preBidDaysAhead
  createDaysAhead
  startAt
  endAt
  hiddenAt
  sales {
    id
    name
  }
`

const RECURRING_SALE_VARIABLES = `
  $name: String!
  $recurrence: String!
  $frequency: Int!
  $dayOfWeek: Int!
  $weekOfMonth: Int
  $preBidOpenAt: Time
  $preBidDaysAhead: Int
  $createDaysAhead: Int
  $startAt: Time!
  $endAt: Time!
  $startOn: ISO8601Date!
`;

const RECURRING_SALE_ARGUMENTS = `
  name: $name
  recurrence: $recurrence
  frequency: $frequency
  dayOfWeek: $dayOfWeek
  weekOfMonth: $weekOfMonth
  preBidOpenAt: $preBidOpenAt
  preBidDaysAhead: $preBidDaysAhead
  createDaysAhead: $createDaysAhead
  startAt: $startAt
  endAt: $endAt
  startOn: $startOn
`;

const RECURRING_SALE_FIELDS_AND_ERRORS = `
  recurringSale {
    ${RECURRING_SALE_FIELDS}
  }
  ${ERRORS}
`;

export const RECURRING_SALES_WITH_COUNT = gql`
  query (
    ${WITH_COUNT_VARIABLES}
  ) {
    recurringSalesWithCount(
      ${WITH_COUNT_ARGUMENTS}
    ) {
      entries {
        ${RECURRING_SALE_FIELDS}
      }
      count
    }
  }
`;

export const CREATE_RECURRING_SALE = gql`
  mutation CreateRecurringSale(
    ${RECURRING_SALE_VARIABLES}
  ) {
    createRecurringSale(
      ${RECURRING_SALE_ARGUMENTS}
    ) {
      ${RECURRING_SALE_FIELDS_AND_ERRORS}
    }
  }
`;

export const UPDATE_RECURRING_SALE = gql`
  mutation UpdateRecurringSale(
    $id: ID!
    ${RECURRING_SALE_VARIABLES}
  ) {
    updateRecurringSale(
      id: $id
      ${RECURRING_SALE_ARGUMENTS}
    ) {
      ${RECURRING_SALE_FIELDS_AND_ERRORS}
    }
  }
`;

export const RECURRING_SALE = gql`
  query RecurringSale($id: ID!) {
    recurringSale(id: $id) {
      ${RECURRING_SALE_FIELDS}
    }
  }
`;

export const HIDE_RECURRING_SALE = gql`
  mutation HideRecurringSale($id: ID!) {
    hideRecurringSale(id: $id) {
      recurringSale {
        id
      }
      errors {
        message
        path
      }
    }
  }
`;

